import { mapGetters } from 'vuex';

export default {
    name: 'mvtMarketTrendsCTA',
    props: {
        geoInfo: {
            type: Object,
            required: true,
            default: null,
        },
        newDpp: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    computed: {
        ...mapGetters('glb', ['glb']),
    },
};
